var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          staticClass: "align-center"
        },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center flex-wrap",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card-title",
                {
                  staticClass: "pt-0 mr-auto"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.firstApp ? "Deploy your first app" : "Deploy an app"
                    )
                  )
                ]
              ),
              !_vm.firstApp
                ? _c(
                    "gg-btn",
                    {
                      attrs: {
                        tile: "",
                        outlined: "",
                        color: "primary",
                        to: {
                          name: "applications"
                        }
                      }
                    },
                    [_vm._v("Back to applications")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.firstApp && _vm.step === "app"
        ? _c(
            "p",
            {
              staticClass: "apps__muted mb-3"
            },
            [
              _vm._v(
                " Install apps like WordPress, Uptime Kuma or Gitea in a few clicks — on one of your servers, or on a new one we set up for it. "
              )
            ]
          )
        : _vm._e(),
      _c(
        "gg-card",
        [
          _c(
            "gg-card-text",
            {
              staticClass: "pa-0"
            },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "apps-deploy__stepper",
                  attrs: {
                    value: _vm.stepIndex,
                    flat: ""
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    [
                      _vm._l(_vm.steps, function(s, i) {
                        return [
                          i
                            ? _c("v-divider", {
                                key: "div-" + s.key
                              })
                            : _vm._e(),
                          _c(
                            "v-stepper-step",
                            {
                              key: s.key,
                              attrs: {
                                step: i + 1,
                                complete: _vm.stepIndex > i + 1
                              }
                            },
                            [_vm._v(_vm._s(s.label))]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "pa-4"
                },
                [
                  _vm.step === "app"
                    ? [
                        _c(
                          "h3",
                          {
                            staticClass: "body-1 font-weight-medium mb-1"
                          },
                          [_vm._v("Choose the app")]
                        ),
                        _c("kvm-docker-templates", {
                          on: {
                            choose: _vm.onChoose
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm.choice && _vm.step !== "app"
                    ? _c(
                        "gg-card",
                        {
                          staticClass: "mb-4",
                          attrs: {
                            outlined: ""
                          }
                        },
                        [
                          _c(
                            "gg-card-text",
                            {
                              staticClass: "pa-3 d-flex align-center"
                            },
                            [
                              _c("kvm-logo", {
                                staticClass: "mr-3",
                                attrs: {
                                  item: _vm.choice.template,
                                  size: 32,
                                  "default-icon": "mdi-docker"
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "mr-auto"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "body-2 font-weight-medium"
                                    },
                                    [_vm._v(_vm._s(_vm.appTitle))]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "apps__muted text-caption"
                                    },
                                    [_vm._v(_vm._s(_vm.choiceSummary))]
                                  )
                                ]
                              ),
                              _vm.canChange
                                ? _c(
                                    "gg-btn",
                                    {
                                      staticClass: "apps__link",
                                      attrs: {
                                        small: "",
                                        text: ""
                                      },
                                      on: {
                                        click: _vm.changeApp
                                      }
                                    },
                                    [_vm._v("Change")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.step === "where"
                    ? [
                        _vm.loadingServers
                          ? _c(
                              "div",
                              {
                                staticClass: "py-8 text-center",
                                attrs: {
                                  role: "status"
                                }
                              },
                              [
                                _c("v-progress-circular", {
                                  attrs: {
                                    indeterminate: "",
                                    color: "primary",
                                    size: "32",
                                    width: "3",
                                    "aria-hidden": "true"
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "apps__muted mt-2"
                                  },
                                  [_vm._v("Finding your Docker servers…")]
                                )
                              ],
                              1
                            )
                          : [
                              _c(
                                "h3",
                                {
                                  staticClass: "body-1 font-weight-medium mb-1"
                                },
                                [_vm._v("Where should it run?")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "apps__muted mb-3"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.servers.length
                                          ? "Install it on one of your Docker servers, or on a new one."
                                          : "You don’t have a Docker server yet — we’ll set one up for it."
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mt-0",
                                  attrs: {
                                    "hide-details": "",
                                    "aria-label": "Where the app runs"
                                  },
                                  model: {
                                    value: _vm.target,
                                    callback: function callback($$v) {
                                      _vm.target = $$v
                                    },
                                    expression: "target"
                                  }
                                },
                                [
                                  _vm._l(_vm.servers, function(s) {
                                    return _c(
                                      "gg-card",
                                      {
                                        key: s.id,
                                        staticClass: "apps-deploy__option mb-2",
                                        class: {
                                          "apps-deploy__option--on":
                                            _vm.target === s.id
                                        },
                                        attrs: {
                                          outlined: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "gg-card-text",
                                          {
                                            staticClass: "pa-3"
                                          },
                                          [
                                            _c("v-radio", {
                                              attrs: {
                                                value: s.id,
                                                disabled: !!_vm.unavailable(s)
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function fn() {
                                                      return [
                                                        _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "body-2 font-weight-medium"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(s.name)
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "apps__muted text-caption"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.unavailable(
                                                                    s
                                                                  ) ||
                                                                    _vm.details(
                                                                      s
                                                                    )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            !_vm.unavailable(s)
                                              ? _c("kvm-server-resources", {
                                                  staticClass:
                                                    "apps-deploy__res",
                                                  attrs: {
                                                    server: s
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  _c(
                                    "gg-card",
                                    {
                                      staticClass: "apps-deploy__option",
                                      class: {
                                        "apps-deploy__option--on":
                                          _vm.target === "new"
                                      },
                                      attrs: {
                                        outlined: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "gg-card-text",
                                        {
                                          staticClass: "pa-3"
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              value: "new"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function fn() {
                                                    return [
                                                      _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "body-2 font-weight-medium"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "A new server"
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "apps__muted text-caption"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " We build a server with Docker and install " +
                                                                _vm._s(
                                                                  _vm.appTitle
                                                                ) +
                                                                " on it for you. You choose the plan next. "
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              3027233420
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "mt-4"
                                },
                                [
                                  _c(
                                    "gg-btn",
                                    {
                                      staticClass: "apps__btn",
                                      attrs: {
                                        tile: "",
                                        color: "primary",
                                        disabled: !_vm.target
                                      },
                                      on: {
                                        click: _vm.goToServerStep
                                      }
                                    },
                                    [_vm._v("Continue")]
                                  )
                                ],
                                1
                              )
                            ]
                      ]
                    : _vm.step === "install"
                    ? [
                        _vm.install.loading || _vm.install.submitting
                          ? _c(
                              "div",
                              {
                                staticClass: "py-8 text-center",
                                attrs: {
                                  role: "status"
                                }
                              },
                              [
                                _c("v-progress-circular", {
                                  attrs: {
                                    indeterminate: "",
                                    color: "primary",
                                    size: "32",
                                    width: "3",
                                    "aria-hidden": "true"
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "apps__muted mt-2"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.install.submitting
                                            ? "Installing "
                                                .concat(_vm.appTitle, " on ")
                                                .concat(
                                                  _vm.targetServer.name,
                                                  "\u2026"
                                                )
                                            : "Checking ".concat(
                                                _vm.targetServer
                                                  ? _vm.targetServer.name
                                                  : "the server",
                                                "\u2026"
                                              )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm.install.result
                          ? [
                              _c("applications-operations", {
                                attrs: {
                                  "service-id": _vm.target
                                }
                              }),
                              _c(
                                "v-alert",
                                {
                                  staticClass: "apps__alert mb-3",
                                  attrs: {
                                    type: "success",
                                    dense: "",
                                    text: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    " Installing " +
                                      _vm._s(_vm.appTitle) +
                                      " on " +
                                      _vm._s(_vm.targetServer.name) +
                                      " — you can follow its progress above. "
                                  )
                                ]
                              ),
                              _vm._l(_vm.install.notes, function(n) {
                                return _c(
                                  "p",
                                  {
                                    key: n,
                                    staticClass: "apps__muted text-caption mb-2"
                                  },
                                  [_vm._v(_vm._s(n))]
                                )
                              }),
                              _vm.installUrl
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "mb-2"
                                    },
                                    [
                                      _vm._v(" It will be at "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "apps__link",
                                          attrs: {
                                            href: _vm.installUrl,
                                            target: "_blank",
                                            rel: "noopener"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.installUrl))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "apps__muted text-caption"
                                        },
                                        [
                                          _vm._v(
                                            " once it has started (HTTPS is set up on the first visit)."
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.generatedList.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mb-3"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "subtitle-2 mb-1"
                                        },
                                        [
                                          _vm._v(
                                            "Sign-in details — also kept on the app's Manage page"
                                          )
                                        ]
                                      ),
                                      _vm._l(_vm.generatedList, function(g) {
                                        return _c(
                                          "div",
                                          {
                                            key: g.key,
                                            staticClass:
                                              "d-flex align-center mb-1"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "apps__muted text-caption mr-2",
                                                staticStyle: {
                                                  "min-width": "140px"
                                                }
                                              },
                                              [_vm._v(_vm._s(g.label))]
                                            ),
                                            _c("kvm-copyable", {
                                              attrs: {
                                                value: g.value,
                                                display: g.value
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.postDeployHtml
                                ? _c("div", {
                                    staticClass: "apps-deploy__md mb-3",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.postDeployHtml)
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex flex-wrap"
                                },
                                [
                                  _c(
                                    "gg-btn",
                                    {
                                      staticClass: "apps__btn mr-2 mb-2",
                                      attrs: {
                                        tile: "",
                                        color: "primary",
                                        to: {
                                          name: "applications_app",
                                          params: {
                                            serviceId: _vm.target,
                                            app: _vm.install.stack
                                          }
                                        }
                                      }
                                    },
                                    [_vm._v("Manage the app")]
                                  ),
                                  _vm.choice.template.device_pairing
                                    ? _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mr-2 mb-2",
                                          attrs: {
                                            tile: "",
                                            outlined: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function click($event) {
                                              _vm.pairingOpen = true
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                left: "",
                                                small: "",
                                                "aria-hidden": "true"
                                              }
                                            },
                                            [_vm._v("mdi-check-decagram")]
                                          ),
                                          _vm._v("Approve my browser ")
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "gg-btn",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        text: "",
                                        to: {
                                          name: "applications"
                                        }
                                      }
                                    },
                                    [_vm._v("Go to Applications")]
                                  )
                                ],
                                1
                              ),
                              _vm.choice.template.device_pairing
                                ? _c("kvm-docker-pairing", {
                                    attrs: {
                                      "service-id": _vm.target,
                                      stack: _vm.install.stack,
                                      "app-name": _vm.appTitle
                                    },
                                    model: {
                                      value: _vm.pairingOpen,
                                      callback: function callback($$v) {
                                        _vm.pairingOpen = $$v
                                      },
                                      expression: "pairingOpen"
                                    }
                                  })
                                : _vm._e()
                            ]
                          : [
                              _c(
                                "h3",
                                {
                                  staticClass: "body-1 font-weight-medium mb-2"
                                },
                                [
                                  _vm._v(
                                    "Couldn't install on " +
                                      _vm._s(_vm.targetServer.name)
                                  )
                                ]
                              ),
                              _c(
                                "v-alert",
                                {
                                  staticClass: "apps__alert mb-3",
                                  attrs: {
                                    type: "warning",
                                    dense: "",
                                    text: "",
                                    role: "alert"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.install.error))]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "apps-deploy__facts mb-3"
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "apps__muted"
                                      },
                                      [_vm._v("App name")]
                                    ),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.install.stack))
                                    ])
                                  ]),
                                  _vm.install.hostname
                                    ? _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "apps__muted"
                                          },
                                          [_vm._v("Address")]
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            "https://" +
                                              _vm._s(_vm.install.hostname)
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._l(_vm.install.notes, function(n) {
                                return _c(
                                  "p",
                                  {
                                    key: n,
                                    staticClass: "apps__muted text-caption mb-1"
                                  },
                                  [_vm._v(_vm._s(n))]
                                )
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "mt-4"
                                },
                                [
                                  _c(
                                    "gg-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        text: ""
                                      },
                                      on: {
                                        click: function click($event) {
                                          _vm.step = "where"
                                        }
                                      }
                                    },
                                    [_vm._v("Back")]
                                  ),
                                  _c(
                                    "gg-btn",
                                    {
                                      staticClass: "apps__btn",
                                      attrs: {
                                        tile: "",
                                        color: "primary"
                                      },
                                      on: {
                                        click: _vm.doInstall
                                      }
                                    },
                                    [_vm._v("Try again")]
                                  )
                                ],
                                1
                              )
                            ]
                      ]
                    : _vm.step === "order"
                    ? [
                        _c(
                          "gg-btn",
                          {
                            staticClass: "apps__link ml-n2 mb-2",
                            attrs: {
                              small: "",
                              text: ""
                            },
                            on: {
                              click: function click($event) {
                                _vm.step = "where"
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  left: "",
                                  small: "",
                                  "aria-hidden": "true"
                                }
                              },
                              [_vm._v("mdi-arrow-left")]
                            ),
                            _vm._v("Back ")
                          ],
                          1
                        ),
                        _c(
                          "h3",
                          {
                            staticClass: "body-1 font-weight-medium mb-1"
                          },
                          [_vm._v("Your new server")]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "apps__muted text-caption mb-0"
                          },
                          [
                            _vm._v(
                              "It's built with Docker, and " +
                                _vm._s(_vm.appTitle) +
                                " is installed on it as soon as it's ready."
                            )
                          ]
                        ),
                        _c("hosting-kvm-order", {
                          attrs: {
                            embedded: ""
                          },
                          on: {
                            ordered: _vm.onOrdered
                          }
                        })
                      ]
                    : _vm.step === "setup"
                    ? [
                        _c(
                          "div",
                          {
                            attrs: {
                              "aria-live": "polite"
                            }
                          },
                          [
                            _vm.setup.error
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "apps__alert-strong",
                                    attrs: {
                                      type: "error",
                                      border: "left",
                                      role: "alert"
                                    }
                                  },
                                  [
                                    _vm._v(" " + _vm._s(_vm.setup.error) + " "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mt-2"
                                      },
                                      [
                                        _vm.newServiceId
                                          ? _c(
                                              "gg-btn",
                                              {
                                                staticClass: "error--text",
                                                attrs: {
                                                  small: "",
                                                  tile: "",
                                                  color: "white",
                                                  to: _vm.serverRoute
                                                }
                                              },
                                              [_vm._v("Open the server")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm.setupDone
                              ? [
                                  _vm.appInstalled
                                    ? _c(
                                        "v-alert",
                                        {
                                          staticClass: "apps__alert-strong",
                                          attrs: {
                                            type: "success",
                                            border: "left"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.appTitle) +
                                              " is ready on your new server. "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "v-alert",
                                        {
                                          staticClass: "apps__alert-strong",
                                          attrs: {
                                            type: "warning",
                                            border: "left"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Your server is ready, but " +
                                              _vm._s(_vm.appTitle) +
                                              " wasn't installed: " +
                                              _vm._s(_vm.appProblem) +
                                              " You can deploy it from Applications. "
                                          )
                                        ]
                                      ),
                                  _vm.appInstalled
                                    ? [
                                        _vm.installState && _vm.installState.url
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "mb-2"
                                              },
                                              [
                                                _vm._v(" Open it at "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "apps__link",
                                                    attrs: {
                                                      href:
                                                        _vm.installState.url,
                                                      target: "_blank",
                                                      rel: "noopener"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.installState.url
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "apps__muted text-caption"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " (HTTPS is set up on the first visit)"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.installState &&
                                        _vm.installState.note
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "apps__muted mb-2"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.installState.note)
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.setup.dnsNote
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "apps__muted mb-2"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.setup.dnsNote)
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.appDetails &&
                                        _vm.appDetails.credentials.length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "mb-3"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "subtitle-2 mb-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Sign-in details — also on the app's Manage page"
                                                    )
                                                  ]
                                                ),
                                                _vm._l(
                                                  _vm.appDetails.credentials,
                                                  function(c) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: c.label,
                                                        staticClass:
                                                          "d-flex align-center mb-1"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "apps__muted text-caption mr-2",
                                                            staticStyle: {
                                                              "min-width":
                                                                "140px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(c.label)
                                                            )
                                                          ]
                                                        ),
                                                        _c("kvm-copyable", {
                                                          attrs: {
                                                            value: c.value,
                                                            display: c.value
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex flex-wrap mt-3"
                                    },
                                    [
                                      _vm.appInstalled
                                        ? _c(
                                            "gg-btn",
                                            {
                                              staticClass:
                                                "apps__btn mr-2 mb-2",
                                              attrs: {
                                                tile: "",
                                                color: "primary",
                                                to: {
                                                  name: "applications_app",
                                                  params: {
                                                    serviceId: _vm.newServiceId,
                                                    app: _vm.choice.stack
                                                  }
                                                }
                                              }
                                            },
                                            [_vm._v("Manage the app")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mr-2 mb-2",
                                          attrs: {
                                            tile: "",
                                            outlined: "",
                                            color: "primary",
                                            to: _vm.serverRoute
                                          }
                                        },
                                        [_vm._v("Open the server")]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mb-2",
                                          attrs: {
                                            text: "",
                                            to: {
                                              name: "applications"
                                            }
                                          }
                                        },
                                        [_vm._v("Go to Applications")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : [
                                  _c(
                                    "ol",
                                    {
                                      staticClass: "apps-deploy__progress mb-3"
                                    },
                                    _vm._l(_vm.phases, function(p) {
                                      return _c(
                                        "li",
                                        {
                                          key: p.label,
                                          class: "is-" + p.state
                                        },
                                        [
                                          p.state === "active"
                                            ? _c("v-progress-circular", {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  indeterminate: "",
                                                  size: "18",
                                                  width: "2",
                                                  color: "primary",
                                                  "aria-hidden": "true"
                                                }
                                              })
                                            : _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    small: "",
                                                    color:
                                                      p.state === "done"
                                                        ? "success"
                                                        : "grey",
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        p.state === "done"
                                                          ? "mdi-check-circle"
                                                          : "mdi-circle-outline"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" " + _vm._s(p.label) + " ")
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "apps__muted mb-0"
                                    },
                                    [
                                      _vm._v(
                                        " This usually takes a few minutes. You can leave this page — " +
                                          _vm._s(_vm.appTitle) +
                                          " is installed either way, and you'll find it under Applications. "
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }